import React, { Component } from 'react';
import './index.less';
import { connect } from 'dva';
import ABSHomeLeft from './left';
import ABSHomeRight from './right';
import ABSHomeMiddle from './middle';
import ABSPerfectScrollbar from '../../../../components/ABSPerfectScrollBar';
import ABSBackTop from '../../../../components/ABSBackTop';
import { ABSButton } from '../../../../components/ABSButton';
import authService from '../../../services/auth/authService';
import routeConfig from '../../../config/routeConfig';
import ABSAvatar from '../../../../components/ABSAvatar';
import { ABSModal } from '../../../../components/ABSModal';
import ABSFooter from '../../../../components/ABSFooter';
import { delCookie } from '../../../../utils/cookieUtils';
export interface IABSHomeProps {
  login: boolean;
  isShowCompleteProfile: boolean;
}
export interface IABSHomeStates {
  scrollDom: any;
}

class ABSHome extends Component<IABSHomeProps, IABSHomeStates> {
  private scrollDom;
  private modal;

  constructor(prop: any) {
    super(prop);
    this.state = {
      scrollDom: ''
    };
  }
  componentDidMount() {
    this.scrollDom = document.getElementsByClassName('abs-home-page-scrollbar')[0] as HTMLElement;
    if (!this.scrollDom) {
      setTimeout(() => {
        this.componentDidMount();
      }, 200);
    } else {
      this.setState({
        scrollDom: this.scrollDom
      });
    }
    const { isShowCompleteProfile } = this.props;
    // 显示完善用户信息的Modal
    if (isShowCompleteProfile) {
      return;
    }
    let user = authService.getCurrentUser();
    if (user && this.modal && user.isNew === true) {
      user.isNew = false;
      this.modal.show( true );
      authService.setUserCache(user);
    }
    if (authService.checkIsLogin()) {
      delCookie('invitationId');
    }
  }
  // 新用户提示完善履历弹窗
  onGoExpert = () => {
    location.href = routeConfig.userProfile;
  }

  renderNewUserModalContent = () => {
    const user = authService.getCurrentUser();
    const content = (
      <div className="abs-perfect-modal">
        <div className="abs-perfect-modal-person">
          <div className="abs-perfect-modal-person-avatar">
            <ABSAvatar
              size="large"
              imageUrl={user ? user.avatar : ''}
            />
          </div>
          <div className="abs-perfect-modal-person-title">
            你好，<span className="abs-perfect-modal-person-title-name">{user ? user.name : ''}</span> 用户
          </div>
        </div>
        <div className="abs-perfect-modal-content">
          欢迎使用CNABS，完善您的个人履历可以受到更多的用户关注，更好的促进交流合作。还能获取更多积分。
        </div>
        <ABSButton onClick={this.onGoExpert} className="abs-perfect-modal-btn">去完善我的个人履历</ABSButton>
      </div>
    );
    return content;
  }

  render() {
    const { login } = this.props;
    const { scrollDom } = this.state;
    return (
      <div className="abs-home-page-container">
        <ABSPerfectScrollbar className="abs-home-page-scrollbar">
          <div className="abs-home-left">
            <ABSHomeLeft login={login} />
          </div>
          <div className="abs-home-middle">
            {scrollDom ? <ABSHomeMiddle getScrollParent={scrollDom} /> : ''}
          </div>
          <div className="abs-home-right">
            <ABSHomeRight login={login} />
          </div>
          <ABSBackTop dom={this.scrollDom} />
        </ABSPerfectScrollbar>
        <ABSModal
          wrapClassName="abs-new-user-tooltip-modal"
          content={this.renderNewUserModalContent()}
          width={500}
          footer={null}
          ref={view => this.modal = view}
        />
        <ABSFooter />
      </div>
    );
  }
}

function mapStateToProps({ global }: any) {
  const { isShowCompleteProfile } = global;
  return { isShowCompleteProfile };
}

export default connect(mapStateToProps)(ABSHome); 


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/index.tsx